/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { methodofPaymentHead } from "../../../../../config/constant";
import { Image, Space } from "antd";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import {
    Button, Box, TextField, FormControlLabel, Switch,
    TableCell, TableRow
} from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";
import usePrevious from "../../../../Shared/components/Previous";
import { customAlaphabetValidation, emptyValidation } from "../../../../../helpers/validation";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { CustomSelect } from "../../../../Shared/components/CustomSelect";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const ListTable = (props) => {

    const [visible, setVisible] = useState(false);
    const { details, walletDetails, onRequestSort, sortOrder, sortBy, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [name, setName] = useState('');
    const [mopId, setMopId] = useState('');
    const [walletId, setWalletId] = useState('');
    const [description, setDescription] = useState('');
    const [isPaymentService, setIsPaymentService] = useState(false);
    const [errorWalletId, setErrorWalletId] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const dispatch = useDispatch();


    const paymentService = (value) => {
        setIsPaymentService(!value);
        setWalletId('');
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }


    const emptyState = () => {
        setErrorName(false);
        setErrorWalletId(false);
    };

    const emptyStateInput = () => {
        setName('');
        setDescription('');
        setWalletId('');
        setIsPaymentService(false);
    };

    const onEdit = (data) => {
        setVisible(true);
        setMopId(data.id);
        setName(data.method);
        setDescription(data.description);
        setIsPaymentService(data.isPaymentService);
        setWalletId(data.walletId || data.walletId > 0 ? data.walletId : '');
    }


    const onDelete = (data) => {
        setDeleteModal(true);
        setMopId(data.id);
        setName(data.method);
    };


    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const editMop = (e) => {
        e.preventDefault();
        let wallet = true;
        let emptyname = customAlaphabetValidation('Method of payment', name);
        let emptywallet = emptyValidation('Digital Wallet', walletId);
        if (isPaymentService && !emptywallet.isValid) {
            wallet = false
        }
        emptyState();
        if (emptyname.isValid && wallet) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'mop',
                id: mopId,
                title: 'Method of payment',
                details: {
                    method: name,
                    description: description,
                    isPaymentService: isPaymentService,
                    walletId: walletId ? walletId : null
                }
            });
        } else {
            if (emptyname.errors) {
                setErrorName(emptyname.errors);
            }
            if (wallet === false && emptywallet.errors) {
                setErrorWalletId(emptywallet.errors);
            }
        }
    }


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message.split("|");
            if (error[0] === 'method') {
                setErrorName(error[1]);
            }
        }
    }, [editDetails, editError, prevEditDetails, prevEditError]);


    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={methodofPaymentHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                <TableCell style={{ width: getColumnWidth(methodofPaymentHead, 0) }}><span style={{ width: getColumnWidth(methodofPaymentHead, 0) }}>{data.method}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(methodofPaymentHead, 1) }}><span style={{ width: getColumnWidth(methodofPaymentHead, 1) }} className={classes.descEllipsis}>{data.description ? data.description : '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Method of Payment', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Method of Payment', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Method of Payment'}</p>

                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Method Of Payment'}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component='form'
                        autoComplete='off'
                        onSubmit={(e) => editMop(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Method Of Payment ", <span key={"Method Of Payment"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={errorName ? true : false}
                                helperText={errorName}
                                value={name}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label='Description'
                                variant={'standard'}
                                value={description}
                                className={clsx(classes.margin30t)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                            <div className={classes.textAlignLeft}>
                                <FormControlLabel
                                    classes={{
                                        label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                    }}
                                    control={<Switch size='small' className={clsx(classes.customSwitch, classes.marginLeft10)}
                                        onChange={(e) => { paymentService(isPaymentService) }}
                                    />}
                                    label="Use Payment Services"
                                    labelPlacement="start"
                                    checked={isPaymentService}
                                    className={clsx(classes.textFieldLableColorCustom, classes.marginLeft0, classes.margin30t)}
                                />
                            </div>
                            <div className={clsx(classes.margin30t, { [classes.disabled]: !isPaymentService })}>
                                <CustomSelect
                                    parentClasses={clsx(classes.labelWidth50)}
                                    lableClasses={clsx(classes.textFieldLableColorCustom)}
                                    customClasses={clsx(classes.dropDownHighlight, classes.dropDownPointer)}
                                    details={walletDetails}
                                    name="Digital Wallet"
                                    onChange={(e) => setWalletId(e.target.value)}
                                    defaultValue={walletId}
                                    error={errorWalletId}
                                    heads={['id', 'name']}
                                />
                                <NavLink to={'#'}>
                                    <Image
                                        src={DeleteIcon}
                                        onClick={() => paymentService(true)}
                                        preview={false}
                                        className={clsx(classes.switchDeleteButton)}
                                    />
                                </NavLink>
                            </div>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                                >
                                    Update & Close
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={mopId} loadTasks={() => loadTasks()} name={name} url={'mop'} title={'Method of payment'} visible={deleteModal} />
        </>
    )
}